<div [class.tile-disabled]="orderEntry?.removed === 'removing'">
  @if ((isFirstOrderEntry$ | async) && componentTexts?.infoBar?.length) {
    <div class="alert alert-info mb-5" data-cy="dcp-info-bar">
      <em class="ds-icon ds-icon--info"></em>
      @if (transactionTypeTexts?.thankYouInfoMessage1 && transactionTypeTexts?.thankYouInfoMessage2) {
        {{transactionTypeTexts?.thankYouInfoMessage1}}
        {{orderEntry?.product?.vendor?.address?.companyName}}
        {{transactionTypeTexts?.thankYouInfoMessage2}}
      } @else {
        {{componentTexts?.infoBar}}
      }
    </div>
  }
  <div>
    <div class="order-item__details">
      <div class="d-flex flex-nowrap justify-content-between udex-px-24 udex-pe-20 udex-pe-sm-24 udex-pt-20">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column">
            <h2
              [class.order-item__name--invalid]="isInvalid"
              class="order-item__name d-flex align-items-center m-0 heading__medium--xxxxs"
            >
              {{orderEntry?.product?.name}}&nbsp;
              @if (orderEntry?.product?.supplierAlternativeAID) {
                {{
                  'common.braces' | cxTranslate: {parameter: orderEntry?.product?.supplierAlternativeAID}
                }}
              }
            </h2>
            <span class="order-item__description body--xxs">{{transactionTypeTexts?.productNameSubLine}}</span>
            @if (isInitialPurchase) {
              <span class="order-item__description body--xxs">{{"cartItems.initialPurchase" | cxTranslate}}</span>
            }
          </div>
        </div>
        <div class="d-none d-sm-block">
          <ng-container [ngTemplateOutlet]="priceTooltip"></ng-container>
        </div>
      </div>
      @if (showRemoveAction) {
        <div class="order-item__remove-button d-flex udex-pe-12 udex-pt-20 udex-pt-sm-8 justify-content-end">
          @if (orderEntry?.removed !== 'removing') {
            <udex-button class="d-none d-sm-block"
                         [disabled]="isActionProhibited$ | async" size="Large"
                         data-cy="mobile-remove-action"
                         (click)="removeAction.emit()" icon="sap-icon://delete" design="Tertiary">
              <span> {{"cartDetails.remove" | cxTranslate}} </span>
            </udex-button>
          } @else {
            <udex-button class="d-none d-sm-block" design="Tertiary">
              <span data-cy='add-to-cart-button-spinner'><ui5-busy-indicator
                size="Medium"
                class="d-none d-sm-flex"
                active></ui5-busy-indicator></span>
            </udex-button>
          }
          <!-- on mobile, show icon only -->
          @if (orderEntry?.removed !== 'removing') {
            <udex-button
              class="d-sm-none"
              [disabled]="isActionProhibited$ | async"
              size="Large"
              data-cy="remove-action"
              icon="sap-icon://delete"
              design="Tertiary"
              (click)="removeAction.emit()"
            >
            </udex-button>
          } @else {
            <udex-button class="d-sm-none" design="Tertiary">
              <span data-cy='add-to-cart-button-spinner'><ui5-busy-indicator
                size="Small"
                class="d-sm-none d-flex"
                active></ui5-busy-indicator></span>
            </udex-button>
          }
        </div>
      }
      @if (isInvalid) {
        <div class="order-item__invalid-indicator d-block d-sm-none d-flex justify-content-end udex-pe-20 udex-mt-16">
          <ng-container [ngTemplateOutlet]="priceTooltip"></ng-container>
        </div>
      }
    </div>

    @if (collapsable) {
      <udex-accordion-item #accordionItem [attr.expanded]="!collapsed ? 'true' : null"
                           class="udex-mt-8 udex-mt-sm-0" (click)="toggleCollapsed()"
                           data-cy="order-item-collapse-toggle"
                           title="Product detail" _direction="ltr" desktop>
        <ng-container [ngTemplateOutlet]="accordionItemTemplate"></ng-container>
      </udex-accordion-item>
    } @else {
      <ng-container [ngTemplateOutlet]="accordionItemTemplate"></ng-container>
    }
  </div>
</div>
<ng-template #priceTooltip>
  @if (showPrice && !isInvalid) {
    @if (orderEntry?.product?.configurable && (showCpsPriceTooltip | async)) {
      <dcp-cps-price-details-tooltip [entry]="orderEntry"></dcp-cps-price-details-tooltip>
    } @else {
      <dcp-price-details-tooltip [showPricingTooltip]="commercialModelConfig?.showPricingTooltip" [entry]="orderEntry"
                                 [derivativeCount]="derivativeCount"></dcp-price-details-tooltip>
    }
  }
  @if (isInvalid) {
    <dcp-error-indicator></dcp-error-indicator>
  }
</ng-template>

<ng-template #accordionItemTemplate>
  @if (!isInvalid) {
    <div data-cy="order-entry-attributes">
      @if (commercialModelConfig?.showDeploymentSystems && tenantsList$ | async; as tenantsList) {
        @if (tenantsList[orderEntry?.product?.supplierAlternativeAID].length &&
        tenantsList[orderEntry?.product?.supplierAlternativeAID]; as tenants) {
          <div class="order-item-content body--s">
            <div class="order-item-configuration udex-ps-24 udex-ps-lg-20">
              <div class="order-item-configuration__label">
                <div data-cy="license-material-deployment">
                  {{'configurator.deploymentSystems.deployment' | cxTranslate}}
                </div>
              </div>
              <div class="order-item-configuration__value">
                @if (showEditAction) {
                  <div>
                    <dcp-deployment-systems header="configurator.deploymentSystems.system"
                                            description="configurator.deploymentSystems.description"
                                            [tenantKeys]="tenantKeys" [items]="tenants">
                    </dcp-deployment-systems>
                  </div>
                }
                @if (!showEditAction) {
                  <div>
                    <span class="heading__medium--xxxxs">{{tenants.length}}
                      {{
                        'configurator.deploymentSystems.system' | cxTranslate:{count: tenants.length}
                      }}
                    </span>
                  </div>
                }
              </div>
            </div>
            @if (showEditAction) {
              <div class="hidden-block"></div>
            }
          </div>
        }
      }
      @if (!collapsable) {
        <udex-divider class="d-block udex-px-20 udex-mb-12 udex-mt-4 udex-mt-sm-12"></udex-divider>
      }
      @if (orderEntry?.deployment) {
        <div class="order-item-configuration udex-pb-8 udex-px-20 body--s">
          <div class="order-item-configuration__label">
            <span data-cy="deployment">
              {{transactionTypeTexts?.deployment || ("cartItems.deployment" | cxTranslate)}}{{"common.colon" | cxTranslate}}
            </span>
          </div>
          <div class="order-item-configuration__value">
            <span class="cx-value heading__medium--xxxxs">{{orderEntry?.deployment}}</span>
          </div>
        </div>
      }
      <div class="order-item-content body--s">
        <div class="order-item-content__configurations flex-grow-1">
          @if (entryAdditionalLicenses && !orderEntry?.product?.configurable) {
            <div class="order-item-configuration udex-pb-8 udex-ps-24 udex-ps-lg-20" data-cy="additional-licenses">
              <div class="order-item-configuration__label">
                <span>
                  {{transactionTypeTexts?.quantity || ("cartItems.additionalLicenses" | cxTranslate)}}{{"common.colon" | cxTranslate}}
                </span>
              </div>
              <div class="order-item-configuration__value">
                <div class="udex-col-1">
                  <dcp-metric-text
                    class="heading__medium--xxxxs"
                    [product]="orderEntry?.product"
                    [quantity]="quantity">
                  </dcp-metric-text>
                </div>
              </div>
            </div>
          }
          @if (entryDuration.startDate && entryDuration.endDate && !orderEntry?.product?.configurable) {
            <div class="order-item-configuration udex-pb-8 udex-ps-24 udex-ps-lg-20" data-cy="contract-duration">
              <div class="order-item-configuration__label">
                <span>
                  {{transactionTypeTexts?.duration || ("cartItems.duration" | cxTranslate)}}{{"common.colon" | cxTranslate}}
                </span>
              </div>
              <div class="order-item-configuration__value">
                <span>
                  <span class="text-nowrap heading__medium--xxxxs">
                    {{entryDuration.startDate | dcpDate}} - {{entryDuration.endDate | dcpDate}}
                  </span>&nbsp;
                </span>
              </div>
            </div>
          }
          @if (configurationData?.renewalTypes && transactionTypeTexts?.autoRenewal) {
            <div class="order-item-configuration udex-ps-24 udex-ps-lg-20 udex-mb-8" data-cy="auto-renewal">
              <div class="order-item-configuration__label body--s">
                <span>
                  {{transactionTypeTexts?.autoRenewal}}{{"common.colon" | cxTranslate}}
                </span>
              </div>
              <div class="order-item-configuration__value">
                <span class="text-nowrap heading__medium--xxxxs">
                  @if (configurationData.renewalTypes === 'auto') {
                    {{'configurator.on' | cxTranslate}}
                  }
                  @if (configurationData.renewalTypes !== 'auto') {
                    {{'configurator.off' | cxTranslate}}
                  }
                </span>
              </div>
            </div>
          }
          @if (configurationData && configurationData['EU-Access'] && transactionTypeTexts?.euAccess) {
            <div class="order-item-configuration udex-mb-8 udex-ps-24 udex-ps-lg-20">
              <div class="order-item-configuration__label body--s">
                <span>
                  {{transactionTypeTexts.euAccess}}{{"common.colon" | cxTranslate}}
                </span>
              </div>
              <div class="order-item-configuration__value">
                <span>
                  <span class="heading__medium--xxxxs text-nowrap" data-cy="euAccess">
                    @if (configurationData['EU-Access'] === 'true') {
                      {{'configurator.on' | cxTranslate}}
                    }
                    @if (configurationData['EU-Access'] === 'false') {
                      {{'configurator.off' | cxTranslate}}
                    }
                  </span>
                </span>
              </div>
            </div>
          }
          <dcp-configurator-cart-entry-info class="d-block udex-ps-24 udex-ps-lg-20"></dcp-configurator-cart-entry-info>
        </div>
        <div
          class="order-item-content__edit-button d-flex justify-content-end udex-pe-12 udex-pe-sm-0 udex-mt-8 udex-mt-sm-0 udex-me-sm-12">
          @if (!orderEntry?.product?.configurable) {
            @if (showEditAction) {
              <udex-button class="d-none d-sm-block" [disabled]="isActionProhibited$ | async"
                           (click)="editAction.emit()"
                           design="Tertiary" size="Large" data-cy="edit-entry-btn" icon="sap-icon://edit" tabindex="0">
                <span>
                  {{"cartDetails.edit" | cxTranslate}}
                </span>
              </udex-button>
              <udex-button class="d-sm-none" [disabled]="isActionProhibited$ | async" (click)="editAction.emit()"
                           design="Tertiary" size="Large" data-cy="edit-entry-btn" icon="sap-icon://edit" tabindex="0">
              </udex-button>
            }
          } @else {
            @if (showEditAction) {
              <udex-button data-cy="cpsEdit" size="Large"
                           icon="sap-icon://edit" design="Tertiary" [routerLink]="
                {
                  cxRoute: getRoute(),
                  params: {
                    ownerType: getOwnerType(),
                    entityKey: orderItemService.getEntityKey(orderEntry),
                    displayOnly: false
                  }
                } | cxUrl"
              >
                <span class="d-none d-sm-block">
                  {{"cartDetails.edit" | cxTranslate}}
                </span>
                <span class="d-sm-none"></span>
              </udex-button>
            }
          }
        </div>
      </div>
      <udex-divider></udex-divider>
      <div class="d-flex d-sm-none flex-column align-items-end udex-pe-24 udex-pe-sm-0 udex-py-20 udex-py-sm-0">
        <ng-container [ngTemplateOutlet]="priceTooltip"></ng-container>
      </div>
      <udex-divider class="d-sm-none w-100"></udex-divider>
    </div>
  }
</ng-template>
